import { makeAutoObservable } from 'mobx';
import localStorageUtil from '../clientUtils/localStorageUtil';

class SidebarStore {
    isOpen = false;

    constructor() {
        makeAutoObservable(this);
    }

    loadState() {
        const savedState = localStorageUtil.getItem({ key: 'sidebarState' });
        if (savedState) {
            this.isOpen = savedState.isOpen;
        }
    }

    private saveState() {
        localStorageUtil.setItem({
            key: 'sidebarState',
            value: { isOpen: this.isOpen },
        });
    }

    openSidebar() {
        this.isOpen = true;
        this.saveState();
    }

    closeSidebar() {
        this.isOpen = false;
        this.saveState();
    }
}

export default new SidebarStore();
